import "core-js/modules/es.function.name";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.trim";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
// eslint-disable-next-line import/no-cycle
import http from '@/config/http';
import api from '@/apis/eitsApi'; // eslint-disable-next-line import/no-cycle

import commonApi from '@/apis/commonApi'; // eslint-disable-next-line import/no-cycle

import store from '@/store/index';

var LoginCongfig = /*#__PURE__*/function () {
  function LoginCongfig() {
    _classCallCheck(this, LoginCongfig);
  }

  _createClass(LoginCongfig, [{
    key: "LogOut",
    // 用户登出操作
    value: function LogOut() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.LOGOUT_SDK
        }).then(function () {
          _this.ClearLoginInfo(store.getters.userInfo.userName).then(function () {
            resolve();
          }).catch(function (err) {
            reject(err);
          });
        }).catch(function (error) {
          // 请求失败就会捕获报错信息
          reject(error);
        });
      });
    } // 用户清楚后端登录信息

  }, {
    key: "ClearLoginInfo",
    value: function ClearLoginInfo(userName) {
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.CLEAR_LOGIN_INFO_SDK,
          data: {
            userName: userName
          }
        }).then(function () {
          store.dispatch('FedLogOut').then(function () {
            resolve();
          });
        }).catch(function (error) {
          // 请求失败就会捕获报错信息
          reject(error);
        });
      });
    } // 用户登录操作

  }, {
    key: "Login",
    value: function Login(userInfo) {
      userInfo.name = userInfo.name.trim();
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.LOGIN_SDK,
          data: userInfo
        }).then(function (res) {
          store.dispatch('FedLogin', res).then(function () {
            resolve();
          });
        }).catch(function (error) {
          // 请求失败就会捕获报错信息
          reject(error);
        });
      });
    } // 获取用户信息

  }, {
    key: "GetUserInfo",
    value: function GetUserInfo() {
      return new Promise(function (resolve, reject) {
        http({
          method: 'post',
          url: api.GET_USER_INFO
        }).then(function (response) {
          var userInfo = response.data;

          if (userInfo) {
            store.dispatch('FedSetUserInfo', userInfo).then(function () {
              resolve();
            }).catch(function (err) {
              reject();
            });
          } else {
            reject();
          }
        }).catch(function (error) {
          reject(error);
        });
      });
    } // 获取数字字典

  }, {
    key: "GetDic",
    value: function GetDic() {
      return new Promise(function (resolve, reject) {
        commonApi.getDictList().then(function (res) {
          store.dispatch('SetDic', res.data);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    } // 获取当前法庭类型（区分仲裁和审判）

  }, {
    key: "GetCommonInfo",
    value: function GetCommonInfo() {
      return new Promise(function (resolve, reject) {
        commonApi.getCommonInfo().then(function (res) {
          // console.log('SetCommonInfo', res.data)
          store.dispatch('SetCommonInfo', res.data);
          resolve();
        }).catch(function (error) {
          console.log(error);
          reject(error);
        });
      });
    }
  }]);

  return LoginCongfig;
}();

export { LoginCongfig as default };